<template lang="pug">
div
  v-form(ref="form")
    v-card.pa-6.mt-4.round-xl(outlined)
      div.text-md.font-semibold.neutral700--text Audience eligibility
      .text-sm.neutral700--text(style="margin-top: 2px;") Choose which customer you would like to direct this offers to
      yc-checkbox.mt-5(v-model="offer.to_all_customers" :disabled="disableAudienceEligibilityEveryone")
        template(v-slot:label)
          div.text-md.font-medium.ml-3(:class="disableAudienceEligibilityEveryone ? 'neutral400--text' : 'neutral700--text'") Everyone ({{ summary.totalCustomers }} receipients)
      yc-checkbox.mt-5(v-model="offer.to_all_loyalty_members" :disabled="disableAudienceEligibilityOther")
        template(v-slot:label)
          div.text-md.font-medium.ml-3(:class="disableAudienceEligibilityOther ? 'neutral400--text' : 'neutral700--text'") Loyalty members ({{ summary.totalLoyaltyMembers }} receipients)
      yc-checkbox.mt-5(v-model="audienceGroups" :disabled="disableAudienceEligibilityOther")
        template(v-slot:label)
          div.text-md.font-medium.ml-3(:class="disableAudienceEligibilityOther ? 'neutral400--text' : 'neutral700--text'") By segment
      div.ml-8(v-if="audienceGroups")
        segment-selection(v-model="offer.groups" :parent-offer="offer")
      yc-checkbox.mt-5(v-model="filterCustomers" :disabled="disableAudienceEligibilityOther")
        template(v-slot:label)
          div.text-md.font-medium.ml-3(:class="disableAudienceEligibilityOther ? 'neutral400--text' : 'neutral700--text'") Filter and select customers
      div.ml-8(v-if="filterCustomers")
        customer-selection(v-model="offer.customers" :offer="offer")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SegmentSelection from '@/components/clinic/marketing/SegmentSelection.vue'
import CustomerSelection from '@/components/clinic/marketing/CustomerSelection.vue'

export default {
  components: { SegmentSelection, CustomerSelection },
  data () {
    return {
      audienceGroups: false,
      filterCustomers: false,
      offer: {},
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      storedOffer: 'marketing/getOffer',
      summary: 'marketing/getSummary'
    }),
    disableAudienceEligibilityEveryone () {
      if (this.offer.to_all_loyalty_members) {
        return true
      }
      if (this.audienceGroups) {
        return true
      }
      if (this.filterCustomers) {
        return true
      }
      return false
    },
    disableAudienceEligibilityOther () {
      if (this.offer.to_all_customers) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      let offer = JSON.parse(JSON.stringify(this.storedOffer))
      this.audienceGroups = offer.groups.length > 0
      this.filterCustomers = offer.customers.length > 0
      this.offer = offer
    },
    saveData (quit) {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        this.$emit('error')
        return
      }
      let payload = {
        customers : this.offer.customers,
        to_all_customers: this.offer.to_all_customers,
        to_all_loyalty_members: this.offer.to_all_loyalty_members,
      }
      payload.groups = this.offer.groups.map(m => { return { id: m.id, include_later_members: m.include_later_members } })
      if (!this.audienceGroups) {
        payload.groups = []
      }
      if (!this.filterCustomers) {
        payload.customers = []
      }
      for (const key in payload) {
        if (payload[key] === null) {
          delete payload[key];
        }
      }
      return this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}`, payload)
        .then(resp => {
          this.$store.commit('marketing/setOffer', resp.data)
          if (quit) {
            this.$emit('quit', resp.data.id)
          } else {
            this.$emit('updated', resp.data.id)
          }
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
          this.$emit('error')
        })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>